import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPageStatusActionTypes {
  OpenRequestForm = 'pageState/OPEN_REQUEST_FORM',
  SetFailure = 'pageState/SET_FAILURE',
  SetSubmitting = 'pageState/SET_SUBMITTING',
  SetSuccess = 'pageState/SET_SUCCESS',
  SetPhoneValidation = 'pageState/SET_PHONE_VALIDATION',
}

export type TOpenRequestForm = ITypedReduxAction<EPageStatusActionTypes.OpenRequestForm>;
export type TSetRequestFailure = ITypedReduxAction<EPageStatusActionTypes.SetFailure>;
export type TSetRequestSubmitting = ITypedReduxAction<EPageStatusActionTypes.SetSubmitting>;
export type TSetRequestSuccess = ITypedReduxAction<EPageStatusActionTypes.SetSuccess>;
export type TSetPhoneValidation = ITypedReduxAction<EPageStatusActionTypes.SetPhoneValidation>;

export const openRequestForm = actionGenerator<EPageStatusActionTypes.OpenRequestForm>(
  EPageStatusActionTypes.OpenRequestForm,
);

export const setRequestFailure = actionGenerator<EPageStatusActionTypes.SetFailure>(EPageStatusActionTypes.SetFailure);

export const setRequestSubmitting = actionGenerator<EPageStatusActionTypes.SetSubmitting>(
  EPageStatusActionTypes.SetSubmitting,
);

export const setPhoneValidation = actionGenerator<EPageStatusActionTypes.SetPhoneValidation>(
  EPageStatusActionTypes.SetPhoneValidation,
);

export const setRequestSuccess = actionGenerator<EPageStatusActionTypes.SetSuccess>(EPageStatusActionTypes.SetSuccess);

export type TPageStatusActions =
  | TOpenRequestForm
  | TSetRequestFailure
  | TSetRequestSubmitting
  | TSetRequestSuccess
  | TSetPhoneValidation;
